import script from "./NewPreOrderList.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewPreOrderList.vue?vue&type=script&setup=true&lang=ts"

import "./NewPreOrderList.vue?vue&type=style&index=0&id=0eb35f8c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eb35f8c"]])

export default __exports__